import React from 'react'

import { useLuminairePowerFactor } from '../../../hooks/useLuminaireMetrics'
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { createList } from '../../../../../common/utils/graph.utils'
import { formatDateByPeriod } from '../../../../../common/utils/dateFormatter'
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView'
import { LuminaireMetricFilter } from '../../../types/luminaire.types'
import { AggregateWindow } from '../../../../../features/filter/types/types'

interface Props {
  devEui: string
  filter: LuminaireMetricFilter
}

export default function LuminairePowerFactorChartPresenter({ devEui, filter }: Props) {
  const { powerFactorQuery: query } = useLuminairePowerFactor(devEui, filter)

  if (query.isLoading) {
    return <ProfessionalChartLoader metricName="Facteur de puissance" />
  }

  if (query.isError) {
    return <ChartErrorView metricName="Facteur de puissance" />
  }

  const aggWindow = (filter.aggregateWindow || '1h') as AggregateWindow
  const filterPoint = {
    startDate: filter.startDate,
    stopDate: filter.stopDate,
    aggregateWindow: aggWindow,
  }
  const dataChart = createList(aggWindow, filterPoint, query.data)

  return (
    <ChartLineView
      xAxisData={dataChart.listx.map((item) =>
        formatDateByPeriod(item, aggWindow)
      )}
      data={dataChart.listValue}
      label="Facteur de puissance"
      unit=""
    />
  )
}
